<template>
  <div class="popularizeList">
    <div class="popularizeTab">
      <!-- <div class="popularItem active">巨量千川-直播带货</div> -->
      <div class="searchWapper" style="display: flex">
        <a-page-header :title="title" sub-title="千川乘方-推直播" />
      </div>
    </div>

    <div class="page-container">
      <div class="side-container">
        <div class="sidebar-table-wrapper">
          <div class="tab-sidebar">
            <div
              :class="
                item == 'ALL' ? 'tab-sidebar-item selected' : 'tab-sidebar-item'
              "
              @click="changeItem('ALL')"
            >
              <a-icon
                type="schedule"
                title="全部计划"
                :style="{ fontSize: '16px' }"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        :class="
          item == 'ALL' ? 'contentWapper' : 'contentWapper contentWapperOther'
        "
      >
        <div class="filterOperate">
          <AwemeList
            :dataSource="dataSource"
            action="setAdvertiserId"
            :advertiser_id="advertiser_id"
            @getAdvertiserId="getAdvertiserId"
            v-if="dataSource.length > 0"
          />
          <a-tag
            color="red"
            v-if="order.status"
            style="
              margin-left: 15px;
              width: 570px;
              height: 32px;
              line-height: 32px;
              text-align: left;
              padding-left: 15px;
            "
          >
            <a-icon type="exclamation-circle" />
            温馨提示：
            <span v-if="order.c > 0">
              当前户到期时间为：<b style="margin-right: 10px"
                >[ {{ order.endtime }} ]</b
              >
              当前剩余时间仅剩 <b>{{ order.c }}</b> 天
            </span>
            <span v-else>
              当前已过期 <b>{{ -order.c }}</b> 天
            </span>

            <b
              style="margin-left: 20px; color: #1890ff; cursor: pointer"
              @click="payAccount"
              >[ 立即续费 ]</b
            >
          </a-tag>
          <a-tag
            color="green"
            v-else
            style="
              margin-left: 15px;
              width: 150px;
              height: 32px;
              line-height: 32px;
              text-align: left;
              padding-left: 15px;
              font-weight: bold;
            "
          >
            <a-icon type="rise" /> 数据更新频率：30S
          </a-tag>
        </div>
        <div class="contentBox">
          <div class="tabContentBox">
            <ShowTemplate
              ref="adlist"
              :video_info_aweme_item_id="video_info_aweme_item_id"
              :campaign_scene="campaign_scene"
              :aweme_info_aweme_id="aweme_info_aweme_id"
              product_id=""
              :campaign_id="campaign_id"
              :advertiser_id="advertiser_id"
              :marketing_goal="marketing_goal"
            />
          </div>
        </div>
      </div>
    </div>
    <a-modal
      v-if="order.status"
      :visible="dqvisible"
      :footer="null"
      width="400px"
      @cancel="dqvisible = false"
    >
      <div class="dqtitle">会员到期提醒</div>

      <div class="dqtag">
        <span v-if="order.c > 0"
          >温馨提示：当前剩余时间仅剩
          <b style="color: #fe346e">{{ order.c }}</b> 天
        </span>
        <span v-else
          >温馨提示：您当前授权户已过期
          <b style="color: #fe346e">{{ -order.c }}</b> 天
        </span>
        ,账户到期后将会影响您计划创建、监控等功能，请您及时续费！
      </div>

      <div class="dqbtn">
        <a-button
          style="background: #fe346e; color: #fff; border: none"
          size="large"
          @click="payAccount"
          >在线续费</a-button
        >
        <div class="dqtag">
          <p>
            <img src="@images/kefu2.jpg" style="width: 250px; margin: 0 auto" />
          </p>
          <p>
            <a-icon type="question-circle" /> 添加客服微信，享受会员专属折扣
          </p>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { ShowTemplate } from './components';
import { qcApi, requestHttp } from '@utils/index';
import { Modal } from 'ant-design-vue';
import { Empty } from 'ant-design-vue';
import awemeList from '../batchCreatePlan/components/awemeList.vue';
export default {
  name: 'popularizeList',
  props: {},

  data() {
    return {
      advertiserList: [],
      advertiser_id: '',
      range_date: [],
      dataSource: [],
      marketing_goal: 'LIVE_PROM_GOODS',
      item: 'ALL',
      videotype: 'ALL',
      videolist: [],
      video_info_aweme_item_id: '',
      video_all_count: 0,
      video_tfz_count: 0,
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      product_id: '',
      aweme_info_aweme_id: '',
      awemeList: [],
      searchKey: '',
      awemetype: 'ALL',
      aweme_all_count: 0,
      aweme_tfz_count: 0,
      page: 1,
      loading: false,
      campaign_scene: '',
      title: '账户概览',
      order: {
        status: false,
        endtime: '',
        c: 0,
      },
      dqvisible: true,
      campaign_id: 0,
      campaign_list: [],
      marketing_scene: 'FEED',
    };
  },

  components: {
    AwemeList: awemeList,
    ShowTemplate,
  },

  watch: {},
  mounted() {
    this.getAdvertiserList();
  },
  methods: {
    payAccount() {
      const strUrl = 'https://fuwu.oceanengine.com/product/7349537722594836543';
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.target = '_blank';
      a.href = strUrl;
      a.click();
      document.body.removeChild(a);
    },
    async getEndtime(advertiser_id) {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_ALL_ADVERTISER}`,
        method: 'POST',
        params: {
          type: 'QC',
          status: '',
          advertiser_id: advertiser_id,
        },
      });
      if (code == 0) {
        // this.$message.error(msg);
        return;
      }
      console.log(data);
      if (!data) return;
      let c = data.list[0].c;
      if (data.list[0].order_list.length > 0) {
        let endtime = data.list[0].order_list[0].end_time;
        if (c < 5) {
          this.order.status = true;
        } else {
          this.order.status = false;
        }
        this.order.c = c;
        this.order.endtime = endtime;
      } else {
        this.order.status = true;
        this.order.c = c;
      }
      this.dqvisible = true;
    },
    loadMore() {
      console.log(11112222);
    },
    changeVideo(e) {
      this.searchKey = '';
      this.video_info_aweme_item_id = e;
    },
    changeAweme(e) {
      this.searchKey = '';
      this.aweme_info_aweme_id = e;
    },
    handleVideotypeChange(e) {
      console.log(e);
      this.videotype = e.target.value;
      this.getVideoData();
    },
    handleAwemetypeChange(e) {
      console.log(e);
      this.awemetype = e.target.value;
      this.getNearData();
    },
    changeItem(item) {
      console.log('获取到的', this.advertiser_id);
      this.item = item;
      this.searchKey = '';
      let title = '账户概览';
      // switch (item) {
      //   case 'DAILY_SALE':
      //     title = '日常销售'
      //     break;
      //   case 'LIVE_HEAT':
      //     title = '直播加热'
      //     break;
      //   case 'NEW_CUSTOMER_TRANSFORMATION':
      //     title = '新客转化'
      //     break;
      //   case 'PRODUCT_HEAT':
      //     title = '商品加热'
      //     break;
      //   default:
      //     title = '账户概览'
      //     break;
      // }
      this.title = title;
      if (item == 'ALL') {
        this.campaign_scene = '';
        this.campaign_id = 0;
      } else if (item == 'CAMPAIGN') {
        this.campaign_id = 0;
        this.product_id = '';
        this.campaign_list = [];
        this.campaign_list_get();
      }
    },
    async campaign_list_get() {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_CAMPAIGN_LIST}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          marketing_goal: this.marketing_goal,
          marketing_scene: this.marketing_scene,
          page: 1,
          name: this.searchKey,
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      if (!data) return;
      this.campaign_list = data.list;
      if (data.list.length > 0) {
        this.campaign_id = this.campaign_id
          ? this.campaign_id
          : data.list[0].id;
      }
    },
    changeCampaign(e) {
      // this.searchKey = ''
      this.campaign_id = e;
    },
    getNearDataBySearch() {
      this.awemeList = [];
      this.page = 1;
      this.getNearData();
    },
    async getNearData() {
      console.log(1111);
      this.loading = true;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SXT_AWEME_NEAR_CREATE_NEW}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          marketing_goal: this.marketing_goal,
          awemetype: this.awemetype,
          searchKey: this.searchKey,
        },
      });
      this.loading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.awemeList = data.list;
      if (data.list.length > 0) {
        this.aweme_info_aweme_id = data.list[0].aweme_id;
      } else {
        this.aweme_info_aweme_id = '';
      }
      this.aweme_all_count = data.count;
      this.aweme_tfz_count = data.tfz_count;
      console.log('近期投放', data.list);
    },
    getVideoDataBySearch() {
      this.page = 1;
      this.videolist = [];
      this.getVideoData();
    },
    async getVideoData() {
      console.log(3333);
      this.loading = true;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SXT_VIDEO_LIVE_REPORT}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          marketing_goal: this.marketing_goal,
          videotype: this.videotype,
          pagesize: 20,
          searchKey: this.searchKey,
        },
      });
      this.loading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      console.log(data);
      if (!data) return;
      this.videolist = data.list;
      this.video_all_count = data.count;
      this.video_tfz_count = data.tfz_count;
      if (data.list.length > 0) {
        this.video_info_aweme_item_id = data.list[0].video_info_aweme_item_id;
      } else {
        this.video_info_aweme_item_id = '';
      }
    },
    getAdvertiserId(advertiser_id) {
      console.log('子组件传回的值', advertiser_id);
      this.advertiser_id = advertiser_id;
      this.getEndtime(this.advertiser_id);
      localStorage.setItem('qc_advertiser_id', advertiser_id);
      if (this.item == 'VIDEO') {
        this.getVideoData();
      } else if (this.item == 'AWEME') {
        this.getNearData();
      }
    },
    async getAdvertiserList() {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_ADVERTISER_LIST}`,
        method: 'POST',
        params: {
          type: 'QC',
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      if (!data) return;
      this.advertiserList = data.list;
      this.dataSource = data.list;
      if (data.list.length == 0) {
        Modal.confirm({
          title: '提醒',
          content: '您尚未授权巨量千川账户，是否前往授权？',
          onOk: () => {
            this.$router.replace('/qc_account');
          },
        });
      } else {
        if (localStorage.getItem('qc_advertiser_id')) {
          this.advertiser_id = localStorage.getItem('qc_advertiser_id');
        } else {
          this.advertiser_id = data.list[0].advertiser_id;
        }
        this.getEndtime(this.advertiser_id);
      }
    },
    handleChange(value) {
      console.log(`selected ${value}`);
      this.advertiser_id = value;
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    changeTab(type) {
      this.selectMenuTab = type;
    },
  },
};
</script>

<style lang="less" scoped>
.page-container {
  display: flex;
}
.scroll-box {
  height: 200px;
  overflow-y: auto;
}
.shop-account-item {
  align-items: center;
  border-radius: 4px;
  display: flex;
  height: 80px;
  justify-content: flex-start;
  padding: 16px;
  position: relative;
}
.item-list {
  margin-top: 10px;
}
.shop-account-item.selected {
  background: #edf1fd;
  position: relative;
}
.shop-list {
  cursor: pointer;
}
.byted-avatar-img {
  background: transparent;
}
.byted-avatar-square {
  border-radius: 6px;
}
.byted-avatar-md {
  font-size: 24px;
  height: 48px;
  line-height: 48px;
  width: 48px;
}
.shop-account-avatar {
  border: 1px solid #ebebeb;
  color: #fff;
  overflow: hidden;
  position: relative;
  text-align: center;
  border-radius: 3px;
}
.byted-popover-wrapper {
  text-align: left;
}
.ellipsis-text-component {
  width: 127px;
  font-size: 12px;
  font-weight: 600;
  color: rgb(51, 51, 51);
  cursor: pointer;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  display: -moz-box;
  -moz-line-clamp: 3;
  -moz-box-orient: vertical;
  overflow-wrap: break-word;
  word-break: break-all;
  white-space: normal;
  overflow: hidden;
  line-height: 16px;
}
.shop-account-avatar > img {
  display: block;
  height: 70px;
  width: 50px;
  border-radius: 3px;
}
.shop-account-text {
  margin-left: 9px;
  width: 130px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}
.shop-account-data {
  color: #999;
  font-size: 10px;
  font-weight: 400;
  line-height: 20px;
  margin-top: 8px;
}
.shop-account-item.selected::before {
  background-color: #1890ff;
  border-radius: 4px;
  content: '';
  display: block;
  height: 24px;
  left: 0;
  margin-top: -12px;
  position: absolute;
  top: 50%;
  width: 4px;
}
.slibar-list {
  background-color: #fff;
  border-radius: 8px 0 0;
  border-right: 1px solid #e5e5e5;
  overflow-y: auto;
  padding: 16px;
  transition: width 0.15s ease-in-out;
  width: 300px;
}
.mainContent {
  background: none !important;
}
.ant-page-header {
  padding: 0px 0px 10px 0px;
}
.sidebar-table-wrapper {
  display: flex;
  .tab-sidebar {
    display: flex;
    flex-direction: column;
    width: 44px;
    .tab-sidebar-item {
      cursor: pointer;
      height: 54px;
      padding: 17px 13px;
    }
    .tab-sidebar-item.selected {
      background-color: #fff;
      border-radius: 12px 0 0 12px;
    }
  }
}
.popularizeTab {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .popularItem {
    margin-right: 10px;
    padding: 10px 20px;
    text-align: center;
    border-radius: 5px;
    float: left;
    margin-right: 10px;
    color: #fff;
    cursor: pointer;
  }
  .active {
    background-color: #1890ff;
  }
}

.contentWapper {
  position: relative;
  padding: 20px;
  width: -webkit-calc(100% - 45px);
  width: -moz-calc(100% - 45px);
  width: calc(100% - 45px);
  background-color: #fff;
  .filterOperate {
    display: flex;
    // align-items: center;
    justify-content: flex-start;
  }
  .filterItem {
    margin-right: 15px;
  }
}
.contentWapperOther {
  width: -webkit-calc(100% - 300px);
  width: -moz-calc(100% - 300px);
  width: calc(100% - 300px);
}
.contentBox {
  display: flex;
  align-items: flex-start;
  justify-items: flex-start;
  list-style-type: none;
  margin-top: 10px;
  .tabMenue {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background: #f0f2f5;
    padding: 0px;
    border-radius: 8px;
    .tabIcon {
      height: 40px;
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background: #f0f2f5;
      border-radius: 8px;
      &.selected {
        background: #fff;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
  }
}
.tabContentBox {
  width: 100%;
}
.dqtitle {
  text-align: center;
  font-weight: 600;
  font-size: 18px;
  color: #fe346e;
  margin-bottom: 20px;
}
.dqtag {
  font-size: 14px;
  color: #333;
  text-align: center;
}
.dqbtn {
  margin-top: 20px;
  button {
    margin-bottom: 10px;
    width: 100%;
  }
}
.page-container {
  padding-bottom: 70px !important;
}
/deep/.ant-page-header{
  border-bottom: 1px solid rgb(235, 237, 240);
  padding: 2px 0px 5px 10px;
}
/deep/ .ant-page-header-heading-title{
  font-size: 16px !important;
}
</style>
